import { LocalizedLink as Link } from "./LocalizedLink";
import { useState } from "react";
import {
    Phone,
    Mail,
    MapPin,
    Facebook,
    Instagram,
    Heart
} from "lucide-react";
import TikTokIcon from "./Tiktok";
import { useMessages } from "../context/MessagesContext";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const labels = useMessages();

    const [showAllTreatments, setShowAllTreatments] = useState(false);
    const [showAllSueros, setShowAllSueros] = useState(false);

    const treatments = [
        { label: labels["footer.treatments.celulas"], to: "/tratamientos/celulas-madre" },
        { label: labels["footer.treatments.pdrn"], to: "/tratamientos/pdrn" },
        { label: labels["footer.treatments.implante"], to: "/tratamientos/implante-placenta" },
        { label: labels["footer.treatments.exosomas"], to: "/tratamientos/exosomas-intravenosos" },
        { label: labels["footer.treatments.exosomas.faciales"], to: "/tratamientos/exosomas-faciales" },
        { label: labels["footer.treatments.plasma"], to: "/tratamientos/plasma-rico-plaquetas" },
        { label: labels["footer.treatments.hidrofacial"], to: "/tratamientos/hidrofacial" },
        { label: labels["footer.treatments.celulas.faciales"], to: "/tratamientos/celulas-madre-faciales" },
        { label: labels["footer.treatments.nad"], to: "/tratamientos/nad-intravenoso" }
    ];

    const suerosLinks = [
        { label: labels["footer.sueros.nad"], to: "/sueros/nad" },
        { label: labels["footer.sueros.implante"], to: "/sueros/implante" },
        { label: labels["footer.sueros.shots"], to: "/sueros/shots" },
        { label: labels["footer.sueros.mega"], to: "/sueros/mega" },
        { label: labels["footer.sueros.quelacion"], to: "/sueros/quelacion" },
        { label: labels["footer.sueros.hierro"], to: "/sueros/hierro" },
        { label: labels["footer.sueros.nutri"], to: "/sueros/nutri" },
        { label: labels["footer.sueros.ultra"], to: "/sueros/ultra" },
        { label: labels["footer.sueros.beauty"], to: "/sueros/beauty" },
        { label: labels["footer.sueros.recovery"], to: "/sueros/recovery" },
        { label: labels["footer.sueros.glutation"], to: "/sueros/glutation" },
        { label: labels["footer.sueros.fitness"], to: "/sueros/fitness" },
        { label: labels["footer.sueros.exosomas"], to: "/sueros/exosomas" },
    ];

    const visibleSueros = showAllSueros ? suerosLinks : suerosLinks.slice(0, 5);
    const visibleTreatments = showAllTreatments ? treatments : treatments.slice(0, 5);

    return (
        <footer className="footer-foreground text-background">
            <div className="container mx-auto px-4 lg:px-8 py-11">
                <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                    <div className="lg:col-span-1">
                        <h3 className="text-2xl text-background/80 font-bold mb-4">
                            {labels["footer.brand"]}
                        </h3>

                        <p className="text-background/80 mb-6">
                            {labels["footer.slogan"]}
                        </p>

                        <div className="flex gap-4">
                            <a
                                href="https://www.instagram.com/hidromed.mx/"
                                className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>

                            <a
                                href="https://tiktok.com/@hidromed.mx?_t=ZS-904Goauq4wC&_r=1"
                                className="w-10 h-10 bg-background/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
                            >
                                <TikTokIcon className="w-5 h-5" />
                            </a>

                            <a
                                href="https://facebook.com/p/Hidromed-Tijuana-100076453744281/"
                                className="w-10 h-10 rounded-full flex items-center justify-center bg-[#1877F2] text-white hover:bg-[#145dbf] transition"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>

                            <a
                                href="https://api.whatsapp.com/send?phone=5216641954918"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center hover:bg-green-600 transition"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    className="w-5 h-5 text-white"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M20.52 3.48A11.93 11.93 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.18 1.61 6L0 24l6.21-1.62A11.95 11.95 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.18-3.48-8.52zM12 22a9.96 9.96 0 01-5.09-1.39l-.36-.21-3.68.96.98-3.59-.23-.37A9.94 9.94 0 012 12C2 6.48 6.48 2 12 2c2.66 0 5.18 1.04 7.07 2.93A9.94 9.94 0 0122 12c0 5.52-4.48 10-10 10zm5.27-7.44c-.29-.15-1.71-.84-1.98-.94-.27-.1-.46-.15-.65.15-.2.29-.74.94-.91 1.13-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.32-1.43-.86-.77-1.44-1.72-1.61-2-.17-.29-.02-.45.13-.6.13-.13.29-.34.43-.5.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.52-.07-.15-.65-1.56-.89-2.14-.23-.55-.46-.47-.65-.48h-.55c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.88 1.22 3.08c.15.2 2.1 3.21 5.09 4.5.71.31 1.26.5 1.69.64.71.23 1.35.2 1.86.12.57-.08 1.71-.7 1.95-1.39.24-.68.24-1.27.17-1.39-.07-.12-.26-.19-.55-.34z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4">
                            {labels["footer.linksTitle"]}
                        </h4>

                        <ul className="space-y-2">
                            <li>
                                <Link
                                    to="/"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.home"]}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/sueros"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.sueros"]}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/tratamientos"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.treatments"]}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/empresas"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.empresas"] || "Empresas"}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/nosotros"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.about"]}
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="/contacto"
                                    className="text-background/80 hover:text-accent-gold transition-colors"
                                >
                                    {labels["footer.contact"]}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4">{labels["footer.sueros.label"] || "Sueros"}</h4>

                        <ul className="space-y-2">
                            {visibleSueros.map((suero) => (
                                <li key={suero.to}>
                                    <Link
                                        to={suero.to}
                                        className="text-background/80 hover:text-accent-gold transition-colors"
                                    >
                                        {suero.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {suerosLinks.length > 5 && (
                            <button
                                type="button"
                                onClick={() => setShowAllSueros((v) => !v)}
                                className="mt-5 text-sm text-accent-gold hover:underline"
                            >
                                {showAllSueros ? labels["footer.see.less"] + " ▲" : labels["footer.see.more"] + " ▼"}
                            </button>
                        )}
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4">
                            {labels["footer.treatments"]}
                        </h4>

                        <ul className="space-y-2">
                            {visibleTreatments.map((treatment, idx) => (
                                <li key={idx}>
                                    <Link
                                        to={treatment.to}
                                        className="text-background/80 hover:text-accent-gold transition-colors"
                                    >
                                        {treatment.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {treatments.length > 5 && (
                            <button
                                type="button"
                                onClick={() => setShowAllTreatments((v) => !v)}
                                className="mt-5 text-sm text-accent-gold hover:underline"
                            >
                                {showAllTreatments ? labels["footer.see.less"] + " ▲" : labels["footer.see.more"] + " ▼"}
                            </button>
                        )}
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-4">{labels["footer.contact.label"] || "Contacto"}</h4>

                        <div className="space-y-3">
                            <div className="flex items-start gap-2">
                                <Phone className="w-4 h-4 mt-1 text-accent-gold flex-shrink-0" />
                                <p className="text-background/80 text-sm">
                                    +52 (664) 195-4918
                                </p>
                            </div>

                            <div className="flex items-start gap-2">
                                <Mail className="w-4 h-4 mt-1 text-accent-gold flex-shrink-0" />
                                <p className="text-background/80 text-sm">
                                    hidromed.mx@gmail.com
                                </p>
                            </div>

                            <div className="flex items-start gap-2">
                                <MapPin className="w-5 h-5 text-red-500 drop-shadow-md" />
                                <p className="text-background/80 text-sm">
                                    Blvd. Padre Kino 10840 <br />
                                    Local 1 - 2do Piso <br />
                                    Zona Urbana Rio CP 22010 <br />
                                    Tijuana BC
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-background/20 mt-12 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-background/60 text-sm text-center md:text-left">
                            © {currentYear} {labels["footer.polytics"]}
                        </p>

                        <div className="flex items-center gap-2 text-background/60 text-sm">
                            <span>{labels["footer.made"]}</span>
                            <Heart className="w-4 h-4 text-accent-gold fill-current" />
                            <span>{labels["footer.in"]}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
